import { Injectable, NgZone, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, Subject } from 'rxjs';
import { ViewportRuler } from '@angular/cdk/overlay';

export enum Breakpoint {
  sm = 640,
  md = 768,
  lg = 1024,
  xl = 1280,
  xl2 = 1536,
}

@Injectable({
  providedIn: 'root',
})
export class WindowEventService {
  private _windowResizeSubject: BehaviorSubject<number> = new BehaviorSubject<number>(window.innerWidth);
  private _shellScrollEndSubject: Subject<void> = new Subject<void>();

  constructor(
    private rendererFactory2: RendererFactory2,
    private readonly viewportRuler: ViewportRuler,
    private readonly ngZone: NgZone,
  ) {
    this.createWindowResizeListener();
  }

  public getWindowResizeEvent(): Observable<number> {
    return this._windowResizeSubject.asObservable();
  }

  private createWindowResizeListener(): void {
    this.viewportRuler.change(50).subscribe(() => {
      this.ngZone.run(() => this._windowResizeSubject.next(window.innerWidth));
    });
  }

  public hasShellComponentHasFinishedScrolling(): Promise<void> {
    return firstValueFrom(this._shellScrollEndSubject.asObservable());
  }

  public addEventShellComponentHasFinishedScrolling(): void {
    this._shellScrollEndSubject.next();
  }
}
